export enum CoinPackageNameEnum {
  DIAMOND = 'DIAMOND',
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
}

export enum IncognitoPackageNameEnum {
  INCOGNITO_1_MONTH = 'INCOGNITO_1_MONTH',
  INCOGNITO_3_MONTHS = 'INCOGNITO_3_MONTHS',
  INCOGNITO_6_MONTHS = 'INCOGNITO_6_MONTHS',
  INCOGNITO_12_MONTHS = 'INCOGNITO_12_MONTHS',
}

export enum BoostPackageNameEnum {
  BOOST_1_HOUR = 'BOOST_1_HOUR',
  BOOST_6_HOURS = 'BOOST_6_HOURS',
  BOOST_24_HOURS = 'BOOST_24_HOURS',
}
